import React from 'react';

import Header from '../components/Header';
import Background from '../components/Background';
import Footer from '../components/Footer';
import PromoteCard from '../components/Promote/PromoteCard';

export default function Promote() {
    return (
        <>
            <Header />
            <Background />
            <PromoteCard />
            <Footer />
        </>
    )
}